import { useConfig } from "@jti/app-context/useConfig";
import { useGetTradeInEligibility } from "@jti/rest-api";
import { useUser } from "@jti/ui/hooks/useUser";

import type { TradeInDisabledData } from "@product-details/containers/StandardProductDetailsContainer/components/types";

export const useTradeInDisabled = (isTradeIn: boolean): TradeInDisabledData => {
  const { tradeInOnlyForRegistered } = useConfig();
  const { user } = useUser();

  const getEligibilityQuery = useGetTradeInEligibility(isTradeIn);

  const notDisabledReturn: TradeInDisabledData = { status: "not-disabled" };

  if (!isTradeIn) {
    return notDisabledReturn;
  }

  if (getEligibilityQuery.isLoading) {
    return { status: "loading" };
  }

  if (getEligibilityQuery.isError) {
    return { status: "error" };
  }

  const baseDisabledPayload = { status: "disabled" } as const;

  if (!getEligibilityQuery.data?.isEligible) {
    return { ...baseDisabledPayload, cause: "not-eligible" };
  }

  if (tradeInOnlyForRegistered && !user?.is_device_registered) {
    return { ...baseDisabledPayload, cause: "missing-registered-device" };
  }

  return notDisabledReturn;
};
